// Convocatorias.js
import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, TextField, InputAdornment, Tabs, Tab, Paper, Button, Stack } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import ConvocatoriaCardsGrid from '../components/ConvocatoriaCardsGrid';
import { fetchNoticias } from '../utils/contentfulRequests';

function Convocatorias() {
  const [convocatorias, setConvocatorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [year, setYear] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const allNoticias = await fetchNoticias();
      // Filtrar por categoría "convocatoria"
      const convocatoriasFiltradas = allNoticias.filter(
        (n) =>
          n.categoria &&
          (Array.isArray(n.categoria)
            ? n.categoria.includes("convocatoria")
            : n.categoria === "convocatoria")
      );
      setConvocatorias(convocatoriasFiltradas);
      setLoading(false);
    };
    fetchData();
  }, []);

  const years = [...new Set(convocatorias.map((c) => c.fechaInicio && new Date(c.fechaInicio).getFullYear()).filter(Boolean))].sort((a, b) => b - a);
  const isFinalizada = (item) => {
    const status = String(item.status || '').toLowerCase().trim();
    return status === 'finalizada' || status === 'finalizado' || (item.fechaFinalizacion && new Date(item.fechaFinalizacion) < new Date());
  };
  const filtered = convocatorias.filter((c) => {
    const matchesSearch = c.titulo.toLowerCase().includes(search.toLowerCase()) || c.descripcion.toLowerCase().includes(search.toLowerCase());
    const matchesYear = year === 'all' || (c.fechaInicio && new Date(c.fechaInicio).getFullYear() === year);
    const matchesStatus = statusFilter === 'all' || (statusFilter === 'finalizadas' ? isFinalizada(c) : !isFinalizada(c));
    return matchesSearch && matchesYear && matchesStatus;
  });

  return (
    <Box sx={{ width: '100%', maxWidth: 1220, mx: 'auto', py: 5, px: { xs: 2, md: 3 }, boxSizing: 'border-box' }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Convocatorias
      </Typography>
      <Typography align="center" color="text.secondary" sx={{ maxWidth: 700, mx: 'auto', mb: 4 }}>
        Consulte y descargue las convocatorias vigentes y el histórico de documentos institucionales
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: '280px minmax(0, 1fr)' }, gap: 3, alignItems: 'start', minWidth: 0 }}>
        <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, borderColor: '#dce4ed' }}>
          <Typography sx={{ color: '#54708d', fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', gap: 1 }}><CalendarMonthOutlinedIcon fontSize="small" /> FILTRAR POR AÑO</Typography>
          <Stack sx={{ mt: 2 }}>
            <Button onClick={() => setYear('all')} sx={{ justifyContent: 'space-between', color: year === 'all' ? 'primary.main' : 'text.primary' }}>Todos los años</Button>
            {years.map((itemYear) => <Button key={itemYear} onClick={() => setYear(itemYear)} sx={{ justifyContent: 'space-between', color: year === itemYear ? 'primary.main' : 'text.primary' }}>{itemYear}</Button>)}
          </Stack>
          <Button startIcon={<HistoryOutlinedIcon />} onClick={() => { setYear('all'); setStatusFilter('all'); }} sx={{ mt: 2, pt: 2, width: '100%', justifyContent: 'flex-start', borderTop: '1px solid #edf1f5', borderRadius: 0 }}>Histórico completo</Button>
        </Paper>
        <Box sx={{ minWidth: 0, width: '100%' }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'minmax(0, 1fr) minmax(0, auto)' }, gap: 2, mb: 3, minWidth: 0 }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Buscar por nombre de documento o palabra clave..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
            />
            <Tabs value={statusFilter} onChange={(_, value) => setStatusFilter(value)} variant="scrollable" scrollButtons={false} sx={{ width: '100%', minWidth: 0, backgroundColor: '#eef2f6', borderRadius: 1.5, minHeight: 50, '& .MuiTabs-flexContainer': { minWidth: 'max-content' } }}>
              <Tab value="all" label="Cualquier Estado" />
              <Tab value="vigentes" label="Vigentes" />
              <Tab value="finalizadas" label="Finalizadas" />
            </Tabs>
          </Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <ConvocatoriaCardsGrid items={filtered} tipo="convocatoria" />
      )}
      </Box>
      </Box>
    </Box>
  );
}

export default Convocatorias;